import type { ComponentType, SVGProps } from 'react';
import { useTranslation } from 'react-i18next';
import Tooltip from 'components/Tooltip';

interface SocialMediaItem {
  icon: ComponentType<SVGProps<SVGSVGElement>>;
  link: string;
  label: string;
}

interface FooterSectionProps {
  title: string;
  connect: string;
  termsUrl: string;
  privacyUrl: string;
  social: SocialMediaItem[];
  e2e: string;
}

const FooterSection = ({ title, connect, termsUrl, privacyUrl, social, e2e }: FooterSectionProps) => {
  const { t } = useTranslation();

  return (
    <div data-e2e={`${e2e}-footer-section_container`} className='flex flex-col gap-2'>
      <p className='font-[DKLiquidEmbrace] font-normal text-sm leading-4 tracking-[1.26px] text-brand-grey max-lg:text-start'>
        {title}
      </p>

      <div
        data-e2e={`${e2e}-legal-links`}
        className='flex text-sm text-gray-600 gap-4 max-lg:gap-1 max-lg:flex-col max-lg:items-start'
      >
        <a
          href={termsUrl}
          target='_blank'
          className='hover:underline font-[MuseoSansCyrl] font-normal text-sm text-brand-taupe'
        >
          {t('footer.termsAndConditions')}
        </a>

        <a
          href={privacyUrl}
          target='_blank'
          className='hover:underline font-[MuseoSansCyrl] font-normal text-sm text-brand-taupe'
        >
          {t('footer.privacyPolicy')}
        </a>
      </div>

      <div>
        <p className='font-[MuseoSansCyrl] font-normal text-sm text-brand-grey'>{connect}</p>

        <div data-e2e={`${e2e}-social-links`} className='flex gap-4 mt-2'>
          {social.map(({ icon: Icon, link, label }) => (
            <Tooltip show position='top' text={label} key={label}>
              <div className='w-6 h-6 rounded-full bg-brand-yellow flex items-center justify-center'>
                <a href={link} target='_blank' rel='noreferrer'>
                  <Icon className='block w-3 h-3 shrink-0' />
                </a>
              </div>
            </Tooltip>
          ))}
        </div>
      </div>
    </div>
  );
};

export default FooterSection;
